import { io } from "socket.io-client";
import { EVENTS } from "@flood-watch/shared";

export class GameNetwork {
  constructor(handlers = {}) {
    this.handlers = handlers;
    this.socket = io(import.meta.env.VITE_SERVER_URL || undefined, {
      autoConnect: true,
      transports: ["websocket", "polling"],
      reconnectionDelayMax: 2500,
    });
    this.lastSnapshotAt = 0;
    this.localId = null;
    this.bind();
  }

  bind() {
    this.socket.on("connect", () => {
      this.localId = this.socket.id;
      this.handlers.onConnection?.(true, this.socket.id);
    });
    this.socket.on("disconnect", (reason) => this.handlers.onConnection?.(false, reason));
    this.socket.on("connect_error", () => this.handlers.onConnection?.(false, "retrying"));
    this.socket.on(EVENTS.ROOM_JOINED, (payload) => {
      this.localId = payload.playerId;
      this.handlers.onJoined?.(payload);
    });
    this.socket.on(EVENTS.ROOM_STATE, (payload) => this.handlers.onRoomState?.(payload));
    this.socket.on(EVENTS.COURSE, (payload) => this.handlers.onCourse?.(payload));
    this.socket.on(EVENTS.MATCH_STATE, (payload) => this.handlers.onMatchState?.(payload));
    this.socket.on(EVENTS.REMOTE_SNAPSHOT, (payload) => this.handlers.onRemoteSnapshot?.(payload));
    this.socket.on(EVENTS.PLAYER_LEFT, (payload) => this.handlers.onPlayerLeft?.(payload));
    this.socket.on(EVENTS.ACTION_REJECTED, (payload) => this.handlers.onError?.(payload));
    this.socket.on(EVENTS.SERVER_ERROR, (payload) => this.handlers.onError?.(payload));
  }

  join(name, color) {
    this.socket.emit(EVENTS.QUICK_PLAY, { name, color });
  }

  leave() {
    this.socket.emit(EVENTS.LEAVE_ROOM);
  }

  sendSnapshot(snapshot, force = false) {
    const now = performance.now();
    if ((!force && now - this.lastSnapshotAt < 50) || !this.socket.connected) return;
    this.lastSnapshotAt = now;
    this.socket.emit(EVENTS.PLAYER_SNAPSHOT, snapshot);
  }

  checkpoint(index) {
    this.socket.emit(EVENTS.CHECKPOINT_CLAIM, { index });
  }

  eliminated() {
    this.socket.emit(EVENTS.PLAYER_DEATH, { reason: "water" });
  }

  finish() {
    this.socket.emit(EVENTS.FINISH_CLAIM);
  }

  pickup(platformId) {
    this.socket.emit(EVENTS.PICKUP_CLAIM, { platformId });
  }

  rematch() {
    this.socket.emit(EVENTS.REMATCH_VOTE);
  }
}

export { EVENTS };
